module.exports = {
	"dk": {
		"prod": {
			"freewheelConfig": {
				"siteSectionId": "",
				"videoAssetId": "",
				"midrollCuepoints": [],
				"profileId": {
					"html5": "381929:MTG_Play_Html5_Live"
				},
				"adManagerUrl": "https://mssl.fwmrm.net/p/MTG_Brightcove_HTML5/AdManager.js",
				"serverUrl": "https://5d402.v.fwmrm.net",
				"networkId": "381954",
				"showDisplayAds": true,
				"showPrerolls": true,
				"showMidrolls": true,
				"showPostrolls": true,
				"showOverlays": true,
				"setMidrollSequence": true,
				"siteSectionNetworkId": "381954",
				"useFwId": true,
				"prct": "text/html_doc_lit_mobile,text/html_doc_ref,text/html_lit_nowrapper"
			},
			"adBlockerBlockerConfig": {
				"enabled": true,
				"label": "<div class='video-player-adblock'/>Det ser ud til, at du enten har adblocker software installeret, eller at du prøver at se videoen fra udlandet. For at kunne se vores videoer skal du deaktivere din adblocker software. Genindlæs siden når din adblocker er slået fra. Vi har desværre kun mulighed for at vise vores videoer til brugere i Danmark.</div>",
				"style": "blur"
			},
			"googleAnalyticsConfig": {
				"client": "viasport",
				"eventLabel": "",
				"trackers": [
					{
						"tid": "UA-37272945-2"
					}
				],
				"progressResolution": 100
			},
			"googleTagManagerConfig": {
				"customDimensions": {},
				"dataLayer": "newDataLayer",
				"progressResolution": 5,
				"progressTracking": [
					5,
					10,
					20,
					30,
					40,
					50,
					60,
					70,
					80,
					90,
					95
				]
			}
		},
		"test": {
			"freewheelConfig": {
				"adManagerUrl": "https://mssl.fwmrm.net/p/MTG_Brightcove_HTML5/AdManager.js",
				"serverUrl": "https://5d401.v.fwmrm.net",
				"networkId": "381953",
				"siteSectionNetworkId": "381953"
			},
			"googleAnalyticsConfig": {
				"trackers": [
					{
						"tid": "UA-37272945-14"
					}
				],
				"progressResolution": 100
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/player.json
// module id = 1208
// module chunks = 1 3